import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiUrlService } from '../shared-services/api-url.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SearchPaymentService {

  constructor(
    private readonly http: HttpClient,
    private readonly apiUrlService: ApiUrlService
  ) { }

  getPayementListing(payload:any) {
    let param = new HttpParams();
    for (const key in payload) {
      if (payload.hasOwnProperty(key) && payload[key] !== null && payload[key] !== undefined && payload[key] !== '') {
        param = param.append(key, payload[key]);
      }
    }
    return this.http.get<any>(
      `${this.apiUrlService.GET_PAYMENT_LIST}/payment`,{
        params: param,
      }
    );
  }

  exportCSV(payload: any): Observable<Blob> {
    let param = new HttpParams();
    let header = new HttpHeaders();

    for (const key in payload) {
      if (payload.hasOwnProperty(key) && payload[key] !== null && payload[key] !== undefined && payload[key] !== '') {
        param = param.append(key, payload[key]);
      }
    }
    return this.http.get<Blob>(
      `${this.apiUrlService.GET_PAYMENT_LIST}/payment_excel`,{
        params: param, 
        responseType: 'blob' as 'json'
      }
    );
  }
}
